import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, Product, ProductRetrieve } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteProduct {
  search?: string;
  type?: Product['type'];
}

function useAutoCompleteProduct({
  search,
  type,
}: IUseAutoCompleteProduct): UseQueryResult<AxiosResponse<ProductRetrieve[]>> {
  const fetchAutoCompleteProduct = (): Promise<AxiosResponse<ProductRetrieve[]>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }
    if (type) {
      params.type = type;
    }

    return client.get(`products/auto_complete/?${encodeUrlParams(params)}`);
  };

  return useQuery(['products', search, type], fetchAutoCompleteProduct);
}

export default useAutoCompleteProduct;
